import { useState } from "react";

export const useSendAddress = () => {
  const [isSendAddressModalShown, setIsSendAddressModalShown] = useState(false);

  const handleOpenSendAddressModal = () => {
    setIsSendAddressModalShown(true)
  }

  const handleCloseSendAddressModals = () => {
    setIsSendAddressModalShown(false)
  }

  return {
    handleOpenSendAddressModal,
    isSendAddressModalShown,
    handleCloseSendAddressModals
  }
}



// WEBPACK FOOTER //
// ./src/containers/ChatsPage/SingleChat/hooks/useSendAddress.ts